import './bootstrap';

if (window.LaravelUser && window.Echo) {
    const userId = window.LaravelUser.id;
    const userRole = window.LaravelUser.role;

    const getBrowserDeviceInfo = () => {
        const ua = navigator.userAgent || '';
        let os = 'Unknown OS';
        if (ua.indexOf('Win') !== -1) os = 'Windows';
        else if (ua.indexOf('Mac') !== -1 && !(/iPhone|iPad|iPod/.test(ua))) os = 'macOS';
        else if (/Android/.test(ua)) os = 'Android';
        else if (/iPhone|iPad|iPod/.test(ua)) os = 'iOS';
        else if (ua.indexOf('Linux') !== -1) os = 'Linux';

        let browser = 'Unknown Browser';
        if (ua.indexOf('Firefox') !== -1) browser = 'Firefox';
        else if (ua.indexOf('SamsungBrowser') !== -1) browser = 'Samsung Internet';
        else if (ua.indexOf('Opera') !== -1 || ua.indexOf('OPR') !== -1) browser = 'Opera';
        else if (ua.indexOf('Edge') !== -1 || ua.indexOf('Edg') !== -1) browser = 'Edge';
        else if (ua.indexOf('Chrome') !== -1) browser = 'Chrome';
        else if (ua.indexOf('Safari') !== -1) browser = 'Safari';

        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) || ('ontouchstart' in window);
        return `${browser} on ${os} (${isMobile ? 'Mobile' : 'Desktop'})`;
    };

    const getPwaInstallStatus = () => {
        const isStandalone = window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
        if (isStandalone) return 'Installed';
        if (!('serviceWorker' in navigator)) return 'NA';
        return 'Un Installed';
    };

    const getWebPushStatus = () => {
        if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) return 'NA';
        if (Notification.permission === 'granted') return 'Accepted';
        if (Notification.permission === 'denied') return 'Denied';
        return 'NA';
    };

    window.updateChatFabUnread = (countOrFlag) => {
        const fabContainers = document.querySelectorAll('.chat-fab-container');
        fabContainers.forEach(container => {
            const fabBtn = container.querySelector('.chat-fab-btn');
            const badge = container.querySelector('#chat-fab-unread-badge, .chat-unread-badge');
            const tooltip = container.querySelector('.chat-fab-tooltip');

            if (countOrFlag && countOrFlag !== 0 && countOrFlag !== '0') {
                container.classList.add('has-unread');
                if (fabBtn) fabBtn.classList.add('has-unread');
                if (badge) {
                    badge.style.display = 'flex';
                    badge.textContent = typeof countOrFlag === 'number' && countOrFlag > 1 ? countOrFlag : '!';
                }
                if (tooltip) {
                    tooltip.textContent = 'New message received! Tap to read';
                }
                localStorage.setItem('chat_fab_has_unread', typeof countOrFlag === 'number' ? String(countOrFlag) : '1');
            } else {
                container.classList.remove('has-unread');
                if (fabBtn) fabBtn.classList.remove('has-unread');
                if (badge) {
                    badge.style.display = 'none';
                    badge.textContent = '';
                }
                if (tooltip) {
                    tooltip.textContent = 'Come chat and play!';
                }
                localStorage.removeItem('chat_fab_has_unread');
            }
        });
    };

    if (localStorage.getItem('chat_fab_has_unread')) {
        setTimeout(() => {
            window.updateChatFabUnread(localStorage.getItem('chat_fab_has_unread'));
        }, 100);
    }

    if (userRole === 'Player' && !sessionStorage.getItem('device_info_updated')) {
        sessionStorage.setItem('device_info_updated', 'true');
        axios.post('/api/chat/guest/device-info', {
            device_info: getBrowserDeviceInfo(),
            pwa_status: getPwaInstallStatus(),
            push_status: getWebPushStatus()
        }).catch(() => {});
    }

    // Join global app presence channel
    const presenceChannel = window.Echo.join('app.presence');

    const sendActivity = () => {
        presenceChannel.whisper('player-activity', {
            userId: userId,
            url: window.location.pathname + window.location.search,
            status: 'online',
            deviceInfo: getBrowserDeviceInfo(),
            pwaStatus: getPwaInstallStatus(),
            pushStatus: getWebPushStatus()
        });
    };

    presenceChannel.here(() => {
        sendActivity();
    });

    presenceChannel.listenForWhisper('request-activity', () => {
        sendActivity();
    });

    // Send activity when URL changes or periodically
    window.addEventListener('popstate', sendActivity);
    setInterval(sendActivity, 15000);

    // Setup push notifications for players when not actively on support page
    if (userRole === 'Player') {
        const setupPlayerNotifications = (uuid) => {
            if (!uuid || window._activeChatUuid === uuid) return;
            window._activeChatUuid = uuid;

            const urlBase64ToUint8Array = (base64String) => {
                const padding = '='.repeat((4 - base64String.length % 4) % 4);
                const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
                const rawData = window.atob(base64);
                const outputArray = new Uint8Array(rawData.length);
                for (let i = 0; i < rawData.length; ++i) {
                    outputArray[i] = rawData.charCodeAt(i);
                }
                return outputArray;
            };

            const subscribeToWebPush = async (roomUuid) => {
                if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
                try {
                    const reg = await navigator.serviceWorker.ready;
                    const res = await axios.get('/api/push/vapid-public-key');
                    const publicKey = res.data?.publicKey;
                    if (!publicKey) return;

                    const convertedKey = urlBase64ToUint8Array(publicKey);
                    let subscription = await reg.pushManager.getSubscription();
                    if (!subscription) {
                        subscription = await reg.pushManager.subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: convertedKey
                        });
                    }
                    await axios.post('/api/push/subscribe', {
                        endpoint: subscription.endpoint,
                        keys: {
                            p256dh: subscription.toJSON().keys?.p256dh,
                            auth: subscription.toJSON().keys?.auth
                        },
                        room_uuid: roomUuid
                    });
                } catch (err) {
                    console.error('WebPush subscription failed:', err);
                }
            };

            const requestNotifPermission = () => {
                if (window.Notification && Notification.permission === 'default') {
                    Notification.requestPermission().then(permission => {
                        if (permission === 'granted') subscribeToWebPush(uuid);
                    }).catch(() => {});
                } else if (window.Notification && Notification.permission === 'granted') {
                    subscribeToWebPush(uuid);
                }
            };
            requestNotifPermission();
            window.addEventListener('click', () => requestNotifPermission(), { once: true });

            const channel = window.Echo.private(`chat.${uuid}`);
            channel.listen('MessageSent', (e) => {
                if (!e || !e.message || e.message.sender_type !== 'user') return;

                const isOnSupportPage = window.location.pathname.includes('/support') || window.location.hash.includes('/support');
                const isWindowFocused = !document.hidden && document.hasFocus();

                if (isOnSupportPage && isWindowFocused) {
                    return;
                }

                if (window.updateChatFabUnread) {
                    window.updateChatFabUnread(1);
                }

                const msgId = String(e.message.id || '');
                const lastNotified = localStorage.getItem('last_notified_msg_id');
                if (msgId && lastNotified === msgId) {
                    return;
                }
                if (msgId) {
                    localStorage.setItem('last_notified_msg_id', msgId);
                }

                const title = e.message.user?.name ? `${e.message.user.name} (Support)` : 'New Support Message';
                let bodyText = e.message.message || 'Sent an attachment';
                const tmp = document.createElement('div');
                tmp.innerHTML = bodyText;
                bodyText = tmp.textContent || tmp.innerText || 'New message received';

                const notifTag = msgId ? `support-msg-${msgId}` : 'support-chat-notif';

                const notifOptions = {
                    body: bodyText,
                    icon: '/images/logo-fiesta.webp',
                    badge: '/favicon-96x96.png',
                    tag: notifTag,
                    data: {
                        url: '/portal/support',
                        msg_id: msgId
                    },
                    requireInteraction: true
                };

                if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
                    navigator.serviceWorker.ready.then(registration => {
                        registration.getNotifications({ tag: notifTag }).then(existing => {
                            if (existing && existing.length > 0) return;
                            registration.showNotification(title, notifOptions);
                        });
                    }).catch(() => {
                        if (window.Notification && Notification.permission === 'granted') {
                            const notif = new Notification(title, notifOptions);
                            notif.onclick = () => {
                                window.focus();
                                if (!window.location.pathname.includes('/support') && !window.location.hash.includes('/support')) {
                                    window.location.href = '/portal/support';
                                }
                                notif.close();
                            };
                        }
                    });
                } else if (window.Notification && Notification.permission === 'granted') {
                    const notif = new Notification(title, notifOptions);
                    notif.onclick = () => {
                        window.focus();
                        if (!window.location.pathname.includes('/support') && !window.location.hash.includes('/support')) {
                            window.location.href = '/portal/support';
                        }
                        notif.close();
                    };
                }
            });
        };

        const storedUuid = localStorage.getItem('dashboard_chat_room_uuid');
        if (storedUuid) {
            setupPlayerNotifications(storedUuid);
        }

        axios.get('/api/chat/guest/getRoom').then(res => {
            if (res.data && res.data.uuid) {
                localStorage.setItem('dashboard_chat_room_uuid', res.data.uuid);
                setupPlayerNotifications(res.data.uuid);
                if (typeof res.data.unread_count === 'number' && window.updateChatFabUnread) {
                    window.updateChatFabUnread(res.data.unread_count);
                }
            }
        }).catch(() => {});

        window.addEventListener('chat-room-loaded', (e) => {
            if (e.detail && e.detail.uuid) {
                setupPlayerNotifications(e.detail.uuid);
            }
        });

        window.addEventListener('storage', (e) => {
            if (e.key === 'dashboard_chat_room_uuid' && e.newValue) {
                setupPlayerNotifications(e.newValue);
            }
        });
    }
}
